import React from 'react';
import { Step } from 'components/SteppedModal';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';
import { socialShareModalBlock as block } from 'containers/SocialShareModal/utils';
import { YouTubeSocialShareStep } from '../../types';

export default function useYouTubeVerificationProgressStep(): Step<
  YouTubeSocialShareStep
> {
  return {
    id: 'verification-progress',
    component: (
      <SocialShareModalBody
        showHeader={false}
        isLoading
        loadingTitle="Verifying YouTube account"
        className={block('step-progress')}
      />
    ),
    hideFooter: true,
  };
}
